<mcg-loader [showLoader]="showLoader()"></mcg-loader>
<mcg-grid #ciudadanoContainer id="ciudadanoGrid" #gridCiudadanos [columns]="columnsCiudadanos" [data]="adapterCiudadanos" [configuration]="gridConfig"
  (rowDoubleClick)="rowDoubleClick($event)" (gridRendered)="onGridRendered($event)">
</mcg-grid>
<div #formCiudadano></div>
<div #tarjetasCiudadano></div>
